<template>
    <b-list-group-item
        class="lista-menu"
        v-if="$temAcessoView('SGTEC-REL-03')"
        @click.stop="abrirModal()"
    >
        <span
            >RELAÇÃO GERAL DE ETAPAS
            <b-badge variant="primary">GERENTE</b-badge></span
        >
        <filtro
            ref="filtroModal"
            perfil="gerente"
            :servicos="obterRelatoriosServicos()"
            @filtrar="obterRelatorio($event)"
        ></filtro>
    </b-list-group-item>
</template>
<script>
import download from '../../../../shared/download'
import filtro from '../../relatorios/RelacaoEtapasFiltro'
import RelatoriosServicos from './RelatoriosServicos'

export default {
    components: {
        filtro
    },

    methods: {
        abrirModal() {
            this.$refs.filtroModal.abrir()
        },

        obterRelatorio(filtro) {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterRelatorio(filtro).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Falha ao obter relatório',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        download(response, `Relatorio_Geral_Etapas.xlsx`)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterRelatoriosServicos() {
            return RelatoriosServicos
        }
    }
}
</script>
